import styled from 'styled-components';
export const IconContainer = styled.span.withConfig({
  displayName: "Homestyle__IconContainer",
  componentId: "kjkszh-0"
})(["display:flex;align-items:center;justify-content:center;height:", ";width:", ";background-color:", ";border-radius:", ";"], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.color['fill-accent-green-default'], ({
  theme
}) => theme.borderRadius['full']);